import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { ThomasUserInfo, UserInfo } from 'models/interfaces';
//query{headingLastUpdate{create_datetime}}
const USERINFO_QUERY = gql`
  query getUserInfo {
    UserInfo {
      firstName
      lastName
      roles
      claims
      superUser
    }
  }
`;
interface ThomasUserContainerProps {
  data?: UserInfo;
}

interface ThomasContainerProps {
  children: (props: ThomasUserContainerProps) => any;
}

//class ThomasUserQuery extends Query<UserInfo, any> {}

const UserContainer: React.FunctionComponent<ThomasContainerProps> = ({ children, ...props }) => (
  <Query<UserInfo, any> query={USERINFO_QUERY} fetchPolicy="no-cache">
    {({ data, loading, error }) => {
      if (loading || error) {
        return null;
      }
      if (data === null) {
        data = {} as UserInfo;
      }
      return (
        children &&
        children({
          ...props,
          data
        })
      );
    }}
  </Query>
);

export default UserContainer;
